import request from '@/utils/request';

export async function apiAppAppInit(params: object) {
    return request({
        url: '/api/app/app/init',
        params
    });
}

export async function apiAppAppInfo(params: object) {
    return request({
        url: '/api/app/app/info',
        params
    });
}

export async function apiAppAppRules(params: object) {
    return request({
        url: '/api/app/app/rules',
        params
    });
}

